import { useTheme } from "next-themes";
import useBreakpoint from "../hooks/useBreakpoint";

export function BankAccountCard({ account, selected, onSelect, isRedeem }) {
  const { theme } = useTheme();

  const isDark = theme === "dark";

  const screenSize = useBreakpoint();

  const cardStyle = {
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "space-between",
    padding: screenSize === "sm" ? ".76rem" : "1rem",
    // marginBottom: '1rem',
    borderRadius: "1rem",
    border: "2px solid",
    borderColor: selected ? (isDark ? (isRedeem ? "rgba(207, 98, 213, .5)" : "rgba(45, 104, 201, .6)") : "#1D4ED8") : "transparent",
    background: isDark ? "rgb(20, 28, 40)" : "#FFFFFF",
    boxShadow: selected ? `0 3px 9px ${isRedeem ? "rgba(207, 98, 213, .275)" : "rgba(49, 114, 218, 0.4)"}` : `0 2px 6px rgba(0, 0, 0, 0.15)`,
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  };

  const textStyle = {
    margin: 0,
    color: isDark ? "var(--theme-light-secondary)" : "#111827",
    fontWeight: "600",
    fontFamily: "Inter, sans-serif",
  };
  const subtitleStyle = {
    margin: 0,
    color: isDark ? "#9CA3AF" : "#6B7280",
    fontSize: "0.875rem",
  };

  const subtitleLabelStyle = {
    color: "rgb(124, 132, 144)",
    fontSize: ".8rem",
  };

  return (
    <div className='d-flex align-items-center flex-nowrap gap-3'>
      <input
        className="form-check-input"
        type='checkbox'
        aria-label={`Select ${account.value?.bank_name ?? "account"}`}
        checked={!!selected}
        onChange={(e) => {
          // prevent the parent card click handler from also firing
          e.stopPropagation();
          if (e.target.checked) {
            // select this account
            onSelect(account.value, true);
          } else {
            // deselect - inform parent (pass null so parent can clear selection)
            onSelect(null, true);
          }
        }}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: screenSize === "sm" ? 18 : 20,
          height: screenSize === "sm" ? 18 : 20,
          margin: 0,
          // keep checkbox minimal (no card-like background); use accentColor for the check mark
          // background: "transparent",
          // cursor: "pointer",
        }}
      />
      <div className='row w-100 mx-auto align-items-center flex-nowrap gap-3 animate-card' style={cardStyle} onClick={() => onSelect(account.value, true)}>
        <div className='col-auto p-0'>
          <div
            className='d-flex align-items-center justify-content-center rounded-circle'
            style={{
              width: screenSize === "sm" ? "54px" : "65px",
              height: screenSize === "sm" ? "54px" : "65px",
              color: "rgb(185, 185, 185)",
              border: "1px solid rgb(111, 113, 116)",
              background: "linear-gradient(to right bottom, rgb(164, 89, 169), rgb(41, 95, 161))",
              fontWeight: "600",
              fontSize: screenSize === "sm" ? "1.1rem" : "1.4rem",
            }}
          >
            {/* {account.value.bank_name?.split(' ').map((word) => {
              return word[0]
            })} */}
            {account.value.bank_name}
          </div>
          {/* <img className="" src={DcclLogo} style={{
            width: '65px'
          }}/> */}
        </div>
        <div className='col p-0'>
          <p style={textStyle}>
            <span>{account.value.bank_name}</span>
            <span style={{ ...subtitleLabelStyle, marginLeft: ".7rem" }}>{account.value.branch_name}</span>
          </p>
          <p style={subtitleStyle}>
            <span style={subtitleLabelStyle}>IBAN: </span>
            {account.value.account_no}
          </p>
          <p style={subtitleStyle}>
            <span style={subtitleLabelStyle}>Title: </span>
            {account.value.account_title}
          </p>
        </div>
        {/* <div className='col-auto p-0' style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "1rem",
              height: "1rem",
              borderRadius: "50%",
              border: `2px solid ${selected ? (isDark ? (isRedeem ? "#8b448f" : "#2563EB") : "#1D4ED8") : isDark ? "#374151" : "#D1D5DB"}`,
              background: selected ? (isDark ? (isRedeem ? "#8b448f" : "#2563EB") : "#1D4ED8") : "transparent",
              transition: "all 0.2s",
            }}
          />
        </div> */}
      </div>
    </div>
  );
}
